import { cx } from '@platform/core/lib/cx';
import { Icon } from '../Icon';
import type { IPickerOptionRowProps } from './IPickerOptionRowProps';

/**
 * Рядок плаваючого списку (прототип pickerVM): мін. 32px, відступ 8px + 16px на рівень, крапка 8px (порожня — кільце --line2),
 * підпис із насиченістю пункту й уточненням 11px, бейдж (акцентна пігулка), ✓ акцентом на поточному значенні.
 * Вибір — mousedown із preventDefault, тож фокус лишається на полі.
 */
export function PickerOptionRow({ option: o, id, selected, active, onPick, onHover }: IPickerOptionRowProps) {
  return (
    <div id={id} role="option" aria-selected={selected} aria-disabled={o.disabled || undefined} title={o.title}
      className={cx('pk-opt', active && 'is-hi', o.muted && 'is-muted', o.disabled && 'is-disabled', o.accent && 'is-accent')}
      style={o.indent ? { paddingLeft: 8 + o.indent * 16 } : undefined}
      onMouseDown={(e) => { e.preventDefault(); onPick(); }} onMouseEnter={onHover}>
      {o.icon && <Icon name={o.icon} size={14} strokeWidth={2.2} className="pk-opt__icon" />}
      {o.dot !== undefined && <span className={cx('pk-opt__dot', !o.dot && 'is-hollow')} style={o.dot ? { background: o.dot } : undefined} />}
      <span className="pk-opt__main">
        <span className="pk-opt__label" style={o.weight ? { fontWeight: o.weight } : undefined}>{o.label}</span>
        {o.sub && <span className="pk-opt__sub">{o.sub}</span>}
      </span>
      {o.badge && <span className="pk-opt__badge">{o.badge}</span>}
      <span className="pk-opt__check" aria-hidden>{selected && <Icon name="check" size={14} strokeWidth={2.4} />}</span>
    </div>
  );
}
